export * from './consultation-pending-area-info-note.service';
